/**
 * The outline of the page the user is on, sent with each question so the model
 * starts with it (core/endpoints/assistant.py stores it beside the `[Page: ...]`
 * line) instead of spending a `show_view` round trip on it.
 */
import { outlinePage } from "./assistant-view-outline";

/** The routed view; the support panel and the chat sit outside it. */
export const APP_CONTENT_SELECTOR = '[data-component="app-content"]';

/** Same note as the server adds to a cut `show_view` outline (show_view.py). */
export const outlineCutMarker = (maxChars: number): string =>
	`[The outline was cut at ${maxChars} characters; call show_view again with a focus on one region to read the rest.]`;

/**
 * What the user sees in the routed view, at most `maxChars` long marker
 * included; undefined when the view is missing or cannot be read, so a failing
 * outline never blocks a question.
 */
export const outlineCurrentPage = (
	maxChars: number,
	root: ParentNode = document
): string | undefined => {
	try {
		const content = root.querySelector(APP_CONTENT_SELECTOR);
		if (!content) {
			return undefined;
		}
		const marker = outlineCutMarker(maxChars);
		const { text, truncated } = outlinePage(content, maxChars - marker.length - 1);
		if (!text) {
			return undefined;
		}
		return truncated ? `${text}\n${marker}` : text;
	} catch (error) {
		if (error instanceof Error) {
			console.warn("Could not outline the page", error);
			return undefined;
		}
		throw error;
	}
};
